// ═══ STARTUP DIAGNOSTICS — TEMPORARY ═══
console.log('[STARTUP] index.js executing');

// Catch ALL uncaught errors and make them visible
window.__startupErrors = [];

window.onerror = function(msg, src, line, col, err) {
  const entry = `[onerror] ${msg} at ${src}:${line}:${col}`;
  console.error(entry, err);
  window.__startupErrors.push(entry);
  showErrorOverlay();
  return false;
};

window.onunhandledrejection = function(event) {
  const entry = `[unhandledrejection] ${event.reason?.message || event.reason || 'unknown'}`;
  console.error(entry, event.reason);
  window.__startupErrors.push(entry);
  showErrorOverlay();
};

function showErrorOverlay() {
  // Create a visible error overlay so black-screen failures are diagnosable
  let overlay = document.getElementById('startup-error-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'startup-error-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:#000;color:#ff4444;padding:40px 20px;font-family:monospace;font-size:13px;overflow-y:auto;white-space:pre-wrap;word-break:break-all;';
    document.body.appendChild(overlay);
  }
  overlay.textContent = '⚠ STARTUP ERROR ⚠\n\n' + window.__startupErrors.join('\n\n');
}

console.log('[STARTUP] Error handlers installed');

// ═══ NORMAL APP BOOT ═══
import React from "react";
import ReactDOM from "react-dom/client";

console.log('[STARTUP] React imported');

import "@/index.css";

console.log('[STARTUP] CSS imported');

try {
  console.log('[STARTUP] About to import App...');
  const { default: App } = await import("@/App");
  console.log('[STARTUP] App imported successfully');

  const rootEl = document.getElementById("root");
  if (!rootEl) {
    throw new Error('Root element #root not found in DOM');
  }

  console.log('[STARTUP] Creating React root...');
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  console.log('[STARTUP] React render called');
} catch (err) {
  console.error('[STARTUP] Fatal error during boot:', err);
  window.__startupErrors.push(`[FATAL] ${err.message}\n${err.stack || ''}`);
  showErrorOverlay();
}
